module.exports = __webpack_public_path__ + "static/media/events_principal_responsive.9812c573.png";